import { fetchApi } from '@/config/axiosSetting';
import {
  GetRecievedCorrectiveParamsType,
  GetRecievedCorrectiveResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getRecievedCorrectiveImages/getRecievedCorrectiveImages.type';

export const getInitialVisitRecievedCorrectiveImagesFunction = (
  params: GetRecievedCorrectiveParamsType,
): Promise<GetRecievedCorrectiveResponseType> => {
  return fetchApi.get(
    `/initial/reports/${params.id}/images/corrective/receive/list/`,
  );
};
